/* Theme engagement observations. Commerce success events are emitted by their
 * owners, not inferred from clicks. All delivery uses the consent-aware shared
 * publisher; no vendor scripts or customer/free-text payloads belong here. */
(function () {
  'use strict';
  if (window.__alasilEngagementAnalytics) return;
  window.__alasilEngagementAnalytics = true;

  function currentDeliveryPromise(main) {
    var surface = main?.querySelector?.('[data-delivery-context="pdp"]');
    if (!surface || typeof window.AlAsilDeliveryPromise?.resolve !== 'function') return undefined;
    try {
      var code = window.AlAsilDeliveryPromise.resolve(surface).code;
      return ['today', 'tomorrow', 'next-working-day', 'jet', 'unavailable', 'preorder', 'preorder-review'].indexOf(code) !== -1 ? code : undefined;
    } catch (_) { return undefined; }
  }
  // Resolve only the requested PDP product and an actual selected variant.
  // No title parsing, persisted catalog IDs, or default-variant guesses.
  window.AlAsilProductAnalyticsItem = function (productId, variantId) {
    var main = document.querySelector('[data-analytics-product-id][id^="MainProduct-"]');
    if (!main || (productId && String(productId) !== main.dataset.analyticsProductId)) return null;
    var node = main.querySelector('[data-product-analytics-context]');
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      if (String(data.product_id) !== main.dataset.analyticsProductId) return null;
      var item = {};
      ['product_id', 'item_name', 'item_brand', 'item_category', 'item_group_id', 'sim_type', 'model_family', 'storage', 'color', 'region_version'].forEach(function (key) {
        if (data[key] !== null && data[key] !== undefined && data[key] !== '') item[key] = String(data[key]);
      });
      var input = main.querySelector('form[action*="/cart/add"] [name="id"]');
      // The desktop bundle rail portals the existing purchase form to body.
      // Follow that exact section-owned form, never another card/quick-view.
      if (!input && main.id && main.id.indexOf('MainProduct-') === 0) {
        var purchaseForm = document.getElementById('product-form-' + main.id.slice('MainProduct-'.length));
        if (purchaseForm && purchaseForm.getAttribute('data-type') === 'add-to-cart-form') {
          input = purchaseForm.querySelector('[name="id"]');
        }
      }
      var selectedId = variantId !== undefined ? String(variantId) : input && String(input.value);
      var variant = selectedId && data.variants && data.variants[selectedId];
      if (!variant || String(variant.variant_id) !== selectedId) return item;
      item.variant_id = selectedId;
      if (variant.sku) item.sku = variant.sku;
      if (typeof variant.price === 'number' && Number.isFinite(variant.price)) item.price = variant.price;
      if (typeof variant.compare_at_price === 'number' && Number.isFinite(variant.compare_at_price) && variant.compare_at_price > 0) {
        item.compare_at_price = variant.compare_at_price;
        if (Number.isFinite(item.price) && item.price < variant.compare_at_price) item.discount_pct = Math.round((1 - item.price / variant.compare_at_price) * 10000) / 100;
      }
      if (typeof variant.available === 'boolean') item.stock_status = variant.available ? 'available' : 'unavailable';
      (data.option_names || []).forEach(function (name, index) {
        var key = String(name).toLowerCase().trim();
        var field = { storage: 'storage', storage_capacity: 'storage', color: 'color', colour: 'color', version: 'region_version', region: 'region_version', region_version: 'region_version' }[key];
        if (field && variant.options && variant.options[index]) item[field] = variant.options[index];
      });
      if (variant.item_variant && variant.item_variant !== 'Default Title') item.item_variant = variant.item_variant;
      else {
        var dimensions = [item.storage, item.color, item.region_version].filter(Boolean);
        if (dimensions.length) item.item_variant = dimensions.join(' / ');
      }
      if (selectedId === String(input?.value || '')) {
        var deliveryPromise = currentDeliveryPromise(main);
        if (deliveryPromise) item.delivery_promise = deliveryPromise;
      }
      if (item.model_family) item.item_category2 = item.model_family;
      if (item.storage) item.item_category3 = item.storage;
      var country = window.Shopify && window.Shopify.country;
      if (/^[A-Z]{2}$/.test(country || '') && /^\d+$/.test(item.product_id) && /^\d+$/.test(selectedId)) {
        item.item_id = 'shopify_' + country + '_' + item.product_id + '_' + selectedId;
      }
      return item;
    } catch (_) { return null; }
  };

  function visibleProductId() {
    var id = document.querySelector('[data-analytics-product-id][id^="MainProduct-"]')?.dataset.analyticsProductId;
    var number = Number(id);
    return /^\d+$/.test(id || '') && Number.isSafeInteger(number) && number > 0 ? number : null;
  }
  var viewedProduct = visibleProductId();
  var viewedPath = window.location?.pathname;
  document.addEventListener('linkedOptionsLoaded', function (event) {
    var previousProduct = viewedProduct, previousPath = viewedPath;
    // Denied consent or unavailable delivery must not replay past navigation.
    viewedProduct = visibleProductId();
    viewedPath = window.location?.pathname;
    try {
      if (!previousProduct || !viewedProduct || previousProduct === viewedProduct || previousPath === viewedPath) return;
      var location = window.location;
      if (!/^https:\/\/(www\.)?alasil\.ae$/.test(location.origin) ||
          !/^\/(?:ar\/)?products\/[^/?#]+\/?$/.test(viewedPath) ||
          /[?&]preview_theme_id=/.test(location.search) || window.Shopify?.designMode) return;
      if (typeof event.detail?.url !== 'string' || !event.detail.url) return;
      var committed = new URL(event.detail.url, location.href);
      if (committed.origin !== location.origin || committed.pathname !== viewedPath) return;
      if (window.navigator?.doNotTrack === '1' || window.navigator?.globalPrivacyControl === true ||
          window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true ||
          typeof window.publishAlasilEvent !== 'function') return;
      var detail = {product_id: viewedProduct, previous_product_id: previousProduct,
        page_type: 'product', navigation_source: 'linked_product'};
      var title = window.AlAsilProductAnalyticsItem(viewedProduct, null)?.item_name;
      if (typeof title === 'string' && title.trim()) detail.product = title.trim().slice(0, 200);
      window.publishAlasilEvent('alasil:product_viewed', detail);
    } catch (_) {}
  });

  function track(name, fields, options) {
    if (typeof window.publishAlasilEvent !== 'function') return;
    var main = document.querySelector('[data-analytics-product-id]');
    window.publishAlasilEvent('alasil:storefront_interaction', Object.assign({
      event_name: name, product_id: main ? main.dataset.analyticsProductId : undefined
    }, fields || {}), options);
  }

  // Compare emits this only after accepting an addition (not when the list
  // is full, a family is incompatible, or an already-added item is clicked).
  document.addEventListener('wg:compare_add', function (event) {
    var productId = String((event.detail || {}).product_id || '');
    // The compare store's id is a handle. Do not mislabel it as a Shopify ID.
    if (/^\d+$/.test(productId)) track('compare_added', { product_id: productId });
  });
  document.addEventListener('wg:compare_open', function () {
    track('nav_click', { nav_type: 'compare_tray', item: 'compare' });
  });
  document.addEventListener('alasil:delivery-area-changed', function (event) {
    var area = (event.detail || {}).area;
    var emirates = ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Ras Al Khaimah', 'Fujairah', 'Umm Al Quwain'];
    // Other location events may contain precise addresses/coordinates. Never
    // forward them. This event allows only the seven manual emirate choices.
    if ((event.detail || {}).source === 'manual' && emirates.indexOf(area) !== -1) {
      var deliveryPromise = currentDeliveryPromise(document.querySelector('[data-analytics-product-id][id^="MainProduct-"]'));
      track('location_set', Object.assign({ emirate: area }, deliveryPromise ? { delivery_promise: deliveryPromise } : {}));
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    var tab = target.closest('.cad-spec-tabs__btn');
    if (tab && tab.getAttribute('aria-selected') !== 'true') {
      var name = tab.dataset.tab;
      if (['features', 'highlights', 'specs'].indexOf(name) === -1) return;
      // Let the owning tab handler commit before reporting a viewed panel.
      window.setTimeout(function () {
        if (tab.isConnected && tab.getAttribute('aria-selected') === 'true') track('product_tab_viewed', { tab: name });
      }, 0);
    }
  }, true);

  // Bubble phase observes the widget's preventDefault after its target
  // handler. A capture microtask can run BEFORE that handler on native clicks.
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    var nav = target.closest('.mobile-bottom-menu__item, .mobile-bottom-menu__fab');
    if (nav && !nav.disabled && nav.getAttribute('aria-disabled') !== 'true') {
      var item = nav.dataset.action || nav.dataset.analyticsNavItem;
      if (item === 'collections') item = 'menu';
      if (['home', 'search', 'menu', 'account', 'cart', 'wishlist', 'compare'].indexOf(item) !== -1) {
        var options = window.AlAsilAnalyticsNavigation && window.AlAsilAnalyticsNavigation(event, nav.closest('a[href]'));
        track('nav_click', { nav_type: 'bottom_bar', item: item }, options);
      }
    }
    if (event.defaultPrevented) return;
    var anchor = target.closest('a[href]');
    if (anchor) {
      try {
        var url = new URL(anchor.href, window.location.origin);
        if ((url.protocol === 'https:' && ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].indexOf(url.hostname) !== -1) || url.protocol === 'whatsapp:') {
          // Count the handoff, never claim that a lead/message was delivered.
          // Do not include href: it can contain a phone number and draft text.
          track('contact_click', { channel: 'whatsapp' });
        }
      } catch (_) {}
    }
  });
})();

// Observation segments, not visitor IDs or proof of mental attention. Bulky
// keeps the maximum cumulative counters per segment; never sum checkpoints.
(function () {
  'use strict';
  if (window.__alasilPageAttention || window.AlAsilAnalyticsEnvironment?.enabled === false || !window.performance?.now || !window.crypto?.getRandomValues || !window.addEventListener) return;
  window.__alasilPageAttention = true;
  var segment = null, timer = null;
  var now = function () { return window.performance.now(); };
  function permitted() {
    try { return window.AlAsilAnalyticsEnvironment?.enabled !== false &&
      window.navigator?.doNotTrack !== '1' && window.navigator?.globalPrivacyControl !== true &&
      window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; } catch (_) { return false; }
  }
  function visible() { return document.visibilityState === 'visible'; }
  function focused() { return typeof document.hasFocus === 'function' && document.hasFocus(); }
  function stop() {
    segment = null;
    if (timer !== null) window.clearTimeout(timer);
    timer = null;
  }
  function schedule() {
    if (timer !== null || !segment) return;
    timer = window.setTimeout(function () {
      timer = null;
      checkpoint('interval');
      if (segment?.elapsed >= 1800000) { stop(); start(); }
      schedule();
    }, 15000);
  }
  function start() {
    if (segment || !permitted() || !visible()) return;
    var stamp = now(), bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    segment = {id: Array.from(bytes, function (n) { return n.toString(16).padStart(2, '0'); }).join(''),
      path: window.location.pathname, last: stamp, activity: stamp, active: 0, visible: 0, elapsed: 0,
      wasVisible: visible(), wasFocused: focused(), sent: -1};
    schedule();
  }
  function accrue() {
    if (!permitted()) { stop(); return; }
    if (!segment) return;
    var end = now(), duration = Math.min(Math.max(0, end - segment.last), 1800000 - segment.elapsed);
    if (segment.wasVisible) {
      segment.visible += duration;
      if (segment.wasFocused) segment.active += Math.min(duration, Math.max(0, segment.activity + 60000 - segment.last));
    }
    segment.elapsed += duration;
    segment.last = end;
  }
  function checkpoint(reason) {
    accrue();
    if (!segment || segment.elapsed < 1 || Math.floor(segment.elapsed) === segment.sent) return;
    var detail = {segment_id: segment.id, active_ms: Math.floor(segment.active), visible_ms: Math.floor(segment.visible),
      elapsed_ms: Math.floor(segment.elapsed), reason: reason, page_path: segment.path};
    // Shared closed schema strips unsafe paths before any destination sees it.
    var safe = window.AlAsilAnalyticsPayload?.('alasil:page_attention', detail);
    if (!safe || !safe.page_path || typeof window.publishAlasilEvent !== 'function') return;
    segment.sent = Math.floor(segment.elapsed);
    window.publishAlasilEvent('alasil:page_attention', safe);
  }
  function activity(event) {
    if (!event.isTrusted) return;
    accrue(); start();
    if (segment && visible() && focused()) segment.activity = now();
  }
  // A programmatic scroll also emits a trusted scroll event; observe input
  // intent instead so automatic carousel/anchor scrolling cannot reset idle.
  ['pointerdown', 'keydown', 'wheel', 'touchstart', 'touchmove'].forEach(function (name) {
    document.addEventListener(name, activity, {passive: true, capture: true});
  });
  document.addEventListener('visibilitychange', function () {
    checkpoint('hidden');
    if (!visible()) { stop(); return; }
    start();
  });
  window.addEventListener('blur', function () { accrue(); if (segment) segment.wasFocused = false; });
  window.addEventListener('focus', function () {
    accrue(); start();
    if (segment) { segment.wasFocused = true; segment.activity = now(); }
  });
  window.addEventListener('pagehide', function () { checkpoint('pagehide'); stop(); });
  window.addEventListener('pageshow', start);
  document.addEventListener('visitorConsentCollected', function () { if (!permitted()) stop(); else start(); });
  document.addEventListener('alasil:privacy-ready', start);
  document.addEventListener('alasil:customer-session-account-changed', function () { stop(); start(); });
  document.addEventListener('linkedOptionsLoaded', function () {
    if (!segment || segment.path === window.location.pathname) return;
    checkpoint('interval'); stop(); start();
  });
  // A late privacy API may not emit a new consent event for a returning user.
  var checks = 0;
  function ready() { start(); if (!segment && ++checks < 150) window.setTimeout(ready, 200); }
  ready();
})();
